/**
 * Returns the first value matching the given key in the current url's query params.
 * Use this function rather than the global $a.query_param.
 *
 * @example
 * ```js
 * window.location.search = '?ab_test[foo]=bar&from_navbar=true'
 * queryParam('ab_test[foo]') // 'bar'
 * ```
 *
 * @param key
 */
function queryParam(key: string) {
  // SSR-safe: window is not defined on the server
  if (typeof window === 'undefined') {
    return null;
  }

  const urlSearchParams = new URLSearchParams(window.location.search);
  for (const [queryParamKey, queryParamValue] of urlSearchParams.entries()) {
    if (key === queryParamKey) {
      return queryParamValue;
    }
  }
  return null;
}

export default queryParam;
